import React from "react";

const ViewSVG = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 13.25V14.75C15.75 15.1478 15.592 15.5294 15.3107 15.8107C15.0294 16.092 14.6478 16.25 14.25 16.25H3.75C3.35218 16.25 2.97064 16.092 2.68934 15.8107C2.40804 15.5294 2.25 15.1478 2.25 14.75V13.25"
        stroke="#5893FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 5.75V4.25C15.75 3.85218 15.592 3.47064 15.3107 3.18934C15.0294 2.90804 14.6478 2.75 14.25 2.75H3.75C3.35218 2.75 2.97064 2.90804 2.68934 3.18934C2.40804 3.47064 2.25 3.85218 2.25 4.25V5.75"
        stroke="#5893FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 10.25C9.41421 10.25 9.75 9.91421 9.75 9.5C9.75 9.08579 9.41421 8.75 9 8.75C8.58579 8.75 8.25 9.08579 8.25 9.5C8.25 9.91421 8.58579 10.25 9 10.25Z"
        stroke="#5893FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.208 9.74752C14.264 9.58728 14.264 9.41277 14.208 9.25252C13.7858 8.21784 13.0649 7.33238 12.1373 6.70909C11.2097 6.0858 10.1175 5.75293 9.00001 5.75293C7.88249 5.75293 6.79029 6.0858 5.86272 6.70909C4.93516 7.33238 4.21427 8.21784 3.79201 9.25252C3.736 9.41277 3.736 9.58728 3.79201 9.74752C4.21427 10.7822 4.93516 11.6677 5.86272 12.2909C6.79029 12.9142 7.88249 13.2471 9.00001 13.2471C10.1175 13.2471 11.2097 12.9142 12.1373 12.2909C13.0649 11.6677 13.7858 10.7822 14.208 9.74752Z"
        stroke="#5893FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ViewSVG;
